module.exports = __webpack_public_path__ + "static/img/crd.e1b8733.png";


//////////////////
// WEBPACK FOOTER
// ./lib/imgs/shops/crd.png
// module id = Ry9+
// module chunks = 1